export default __webpack_public_path__ + "static/deliveryStep01-593d2264c5597351ecb0d385c8988ee0.svg";